import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import Section from "apps/website/components/layout/Section/Section";
import Container from "apps/website/components/layout/Container/Container";

import {
  cheeseAfterImage,
  cheeseBeforeImage,
  cleoAfterImage,
  cleoBeforeImage,
} from "./shared/constants";
import SuccessStory from "./components/SuccessStory";

const CHEESE_TESTIMONIAL = <>
  He was so poorly, he wouldn&apos;t open his eyes. Our vet said it was life or death.
  <strong> KatKin literally saved his life.</strong> Now he&apos;s playful, happy and his diarrhoea is gone!
</>;

const CLEO_TESTIMONIAL = <>
  Her eyes are so much clearer. She was skinny and didn&apos;t keep weight on.
  <strong> Best thing we did was change her diet.</strong> Her fur looks so much better too.
</>;

export default function SectionSuccessStories() {
  return (
    <Section component="SectionSuccessStories" theme="light-grey">
      <Container>
        { /* Text Title and Subtitle for the section */ }
        <div className="flex flex-col gap-2 md:gap-6 mb-8 md:mb-10">
          <TextTitle size={1} align="center" className="uppercase">
            FRESH FOOD CHANGES CAT LIVES
          </TextTitle>
          <TextSubtitle size={1} align="center">
            Over 70 million meals delivered for happier, healthier cats.
          </TextSubtitle>
        </div>

        { /* Cheese's Success Story */ }
        <div className="flex flex-col gap-8 lg:gap-10">
          <SuccessStory
            catName="CHEESE"
            testimonial={CHEESE_TESTIMONIAL}
            author="Maisie"
            beforeImage={cheeseBeforeImage}
            afterImage={cheeseAfterImage}
          />

          { /* Cleo's Success Story */ }
          <SuccessStory
            catName="CLEO"
            testimonial={CLEO_TESTIMONIAL}
            author="Elaine"
            beforeImage={cleoBeforeImage}
            afterImage={cleoAfterImage}
            reverse
          />
        </div>
      </Container>
    </Section>
  );
}
